export default __webpack_public_path__ + "static/media/Bloodvaliant Gauntlets.20f7d933.jpg";